 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"ArtistNew":"ArtistNew","ArtistShow~ArtistsIndex~ContactNew~ContactShow~ContactsIndex~EmailShow~EmailTemplateShow~EmailTempla~336a3e1a":"ArtistShow~ArtistsIndex~ContactNew~ContactShow~ContactsIndex~EmailShow~EmailTemplateShow~EmailTempla~336a3e1a","ArtistShow~ArtistsIndex~ContactNew~ContactShow~ContactsIndex~EmailShow~EmailTemplateShow~EmailTempla~578db2ea":"ArtistShow~ArtistsIndex~ContactNew~ContactShow~ContactsIndex~EmailShow~EmailTemplateShow~EmailTempla~578db2ea","ArtistShow~ArtistsIndex~ContactShow~ContactsIndex~EmailShow~EmailTemplateShow~EmailTemplatesIndex~Em~d86950f6":"ArtistShow~ArtistsIndex~ContactShow~ContactsIndex~EmailShow~EmailTemplateShow~EmailTemplatesIndex~Em~d86950f6","ArtistShow~ContactShow~EmailShow~EmailTemplateShow~EventNew~EventShifts~EventShow~NonprofitShow~Shif~2926e872":"ArtistShow~ContactShow~EmailShow~EmailTemplateShow~EventNew~EventShifts~EventShow~NonprofitShow~Shif~2926e872","ArtistShow":"ArtistShow","ContactShow":"ContactShow","EmailShow":"EmailShow","EmailTemplateShow":"EmailTemplateShow","EventNew":"EventNew","EventShifts":"EventShifts","EventShow":"EventShow","NonprofitShow":"NonprofitShow","ShiftShow":"ShiftShow","UserShow":"UserShow","VenueShow":"VenueShow","VolunteerShow":"VolunteerShow","ArtistsIndex":"ArtistsIndex","ContactsIndex":"ContactsIndex","EmailTemplatesIndex":"EmailTemplatesIndex","EmailsIndex":"EmailsIndex","Events~Reports~ShiftNew~Shifts~VolunteersIndex":"Events~Reports~ShiftNew~Shifts~VolunteersIndex","Events":"Events","Reports":"Reports","Shifts":"Shifts","VolunteersIndex":"VolunteersIndex","MetricsIndex":"MetricsIndex","NonprofitsIndex":"NonprofitsIndex","NotesIndex":"NotesIndex","SettingsIndex":"SettingsIndex","UsersIndex":"UsersIndex","VenuesIndex":"VenuesIndex","ContactNew":"ContactNew","ShiftNew":"ShiftNew","MetricNew":"MetricNew","MetricShow":"MetricShow","NonprofitNew":"NonprofitNew","VenueNew":"VenueNew","VolunteertNew":"VolunteertNew","Home":"Home","Login":"Login","SettingNew":"SettingNew","SettingShow":"SettingShow","UserNew":"UserNew"}[chunkId]||chunkId) + "." + {"ArtistNew":"912077a0","ArtistShow~ArtistsIndex~ContactNew~ContactShow~ContactsIndex~EmailShow~EmailTemplateShow~EmailTempla~336a3e1a":"e97d1995","ArtistShow~ArtistsIndex~ContactNew~ContactShow~ContactsIndex~EmailShow~EmailTemplateShow~EmailTempla~578db2ea":"dcd5087f","ArtistShow~ArtistsIndex~ContactShow~ContactsIndex~EmailShow~EmailTemplateShow~EmailTemplatesIndex~Em~d86950f6":"648216be","ArtistShow~ContactShow~EmailShow~EmailTemplateShow~EventNew~EventShifts~EventShow~NonprofitShow~Shif~2926e872":"4e61955c","ArtistShow":"5f4c9e08","ContactShow":"40b47550","EmailShow":"43316682","EmailTemplateShow":"43be7455","EventNew":"b9d0187a","EventShifts":"2ef7a119","EventShow":"350b9f5c","NonprofitShow":"1fd46b1d","ShiftShow":"2274a32d","UserShow":"fa0ebedc","VenueShow":"9f6aa46d","VolunteerShow":"cd4f4d2a","ArtistsIndex":"93a06d1f","ContactsIndex":"6797d22c","EmailTemplatesIndex":"92215c2f","EmailsIndex":"97c1c724","Events~Reports~ShiftNew~Shifts~VolunteersIndex":"afd1da9d","Events":"927258a4","Reports":"4cfca81b","Shifts":"f945fd24","VolunteersIndex":"c4c51240","MetricsIndex":"d98452c3","NonprofitsIndex":"1594f08e","NotesIndex":"677ce726","SettingsIndex":"7137b93d","UsersIndex":"bc29e27a","VenuesIndex":"0331e80a","ContactNew":"1e711dc3","ShiftNew":"c8e3a0a9","MetricNew":"d1faf9d6","MetricShow":"786990c2","NonprofitNew":"8c5e2b93","VenueNew":"8d807971","VolunteertNew":"d315f763","Home":"1a4f1ee8","Login":"b2c96821","SettingNew":"11be0b99","SettingShow":"a8f39378","UserNew":"67c16268"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"ArtistShow~ArtistsIndex~ContactNew~ContactShow~ContactsIndex~EmailShow~EmailTemplateShow~EmailTempla~336a3e1a":1,"ArtistShow~ArtistsIndex~ContactNew~ContactShow~ContactsIndex~EmailShow~EmailTemplateShow~EmailTempla~578db2ea":1,"ArtistShow~ArtistsIndex~ContactShow~ContactsIndex~EmailShow~EmailTemplateShow~EmailTemplatesIndex~Em~d86950f6":1,"ArtistShow~ContactShow~EmailShow~EmailTemplateShow~EventNew~EventShifts~EventShow~NonprofitShow~Shif~2926e872":1,"ArtistShow":1,"EmailShow":1,"EmailTemplateShow":1,"EventNew":1,"EventShifts":1,"EventShow":1,"NonprofitShow":1,"ShiftShow":1,"UserShow":1,"VenueShow":1,"VolunteerShow":1,"ArtistsIndex":1,"ContactsIndex":1,"EmailTemplatesIndex":1,"EmailsIndex":1,"Events~Reports~ShiftNew~Shifts~VolunteersIndex":1,"Events":1,"Reports":1,"Shifts":1,"VolunteersIndex":1,"MetricsIndex":1,"NonprofitsIndex":1,"NotesIndex":1,"SettingsIndex":1,"UsersIndex":1,"VenuesIndex":1,"ContactNew":1,"ShiftNew":1,"MetricNew":1,"MetricShow":1,"NonprofitNew":1,"VenueNew":1,"VolunteertNew":1,"Home":1,"SettingNew":1,"SettingShow":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"ArtistNew":"ArtistNew","ArtistShow~ArtistsIndex~ContactNew~ContactShow~ContactsIndex~EmailShow~EmailTemplateShow~EmailTempla~336a3e1a":"ArtistShow~ArtistsIndex~ContactNew~ContactShow~ContactsIndex~EmailShow~EmailTemplateShow~EmailTempla~336a3e1a","ArtistShow~ArtistsIndex~ContactNew~ContactShow~ContactsIndex~EmailShow~EmailTemplateShow~EmailTempla~578db2ea":"ArtistShow~ArtistsIndex~ContactNew~ContactShow~ContactsIndex~EmailShow~EmailTemplateShow~EmailTempla~578db2ea","ArtistShow~ArtistsIndex~ContactShow~ContactsIndex~EmailShow~EmailTemplateShow~EmailTemplatesIndex~Em~d86950f6":"ArtistShow~ArtistsIndex~ContactShow~ContactsIndex~EmailShow~EmailTemplateShow~EmailTemplatesIndex~Em~d86950f6","ArtistShow~ContactShow~EmailShow~EmailTemplateShow~EventNew~EventShifts~EventShow~NonprofitShow~Shif~2926e872":"ArtistShow~ContactShow~EmailShow~EmailTemplateShow~EventNew~EventShifts~EventShow~NonprofitShow~Shif~2926e872","ArtistShow":"ArtistShow","ContactShow":"ContactShow","EmailShow":"EmailShow","EmailTemplateShow":"EmailTemplateShow","EventNew":"EventNew","EventShifts":"EventShifts","EventShow":"EventShow","NonprofitShow":"NonprofitShow","ShiftShow":"ShiftShow","UserShow":"UserShow","VenueShow":"VenueShow","VolunteerShow":"VolunteerShow","ArtistsIndex":"ArtistsIndex","ContactsIndex":"ContactsIndex","EmailTemplatesIndex":"EmailTemplatesIndex","EmailsIndex":"EmailsIndex","Events~Reports~ShiftNew~Shifts~VolunteersIndex":"Events~Reports~ShiftNew~Shifts~VolunteersIndex","Events":"Events","Reports":"Reports","Shifts":"Shifts","VolunteersIndex":"VolunteersIndex","MetricsIndex":"MetricsIndex","NonprofitsIndex":"NonprofitsIndex","NotesIndex":"NotesIndex","SettingsIndex":"SettingsIndex","UsersIndex":"UsersIndex","VenuesIndex":"VenuesIndex","ContactNew":"ContactNew","ShiftNew":"ShiftNew","MetricNew":"MetricNew","MetricShow":"MetricShow","NonprofitNew":"NonprofitNew","VenueNew":"VenueNew","VolunteertNew":"VolunteertNew","Home":"Home","Login":"Login","SettingNew":"SettingNew","SettingShow":"SettingShow","UserNew":"UserNew"}[chunkId]||chunkId) + "." + {"ArtistNew":"31d6cfe0","ArtistShow~ArtistsIndex~ContactNew~ContactShow~ContactsIndex~EmailShow~EmailTemplateShow~EmailTempla~336a3e1a":"606ed9bb","ArtistShow~ArtistsIndex~ContactNew~ContactShow~ContactsIndex~EmailShow~EmailTemplateShow~EmailTempla~578db2ea":"8a1e79f9","ArtistShow~ArtistsIndex~ContactShow~ContactsIndex~EmailShow~EmailTemplateShow~EmailTemplatesIndex~Em~d86950f6":"0bd65a6d","ArtistShow~ContactShow~EmailShow~EmailTemplateShow~EventNew~EventShifts~EventShow~NonprofitShow~Shif~2926e872":"b341d052","ArtistShow":"2f40b32e","ContactShow":"31d6cfe0","EmailShow":"6b0baa89","EmailTemplateShow":"d3de4bc2","EventNew":"4466aa82","EventShifts":"a469104d","EventShow":"5260b4c3","NonprofitShow":"1d989e03","ShiftShow":"f11c7596","UserShow":"2c969a12","VenueShow":"b45d50d6","VolunteerShow":"3a78d812","ArtistsIndex":"cac2d296","ContactsIndex":"3826ed2b","EmailTemplatesIndex":"3826ed2b","EmailsIndex":"3826ed2b","Events~Reports~ShiftNew~Shifts~VolunteersIndex":"28e8e1af","Events":"4c0c4101","Reports":"ea930da3","Shifts":"cac2d296","VolunteersIndex":"ab2699d2","MetricsIndex":"ebf60f43","NonprofitsIndex":"3826ed2b","NotesIndex":"7f360510","SettingsIndex":"5c7305cb","UsersIndex":"158d7ec5","VenuesIndex":"3826ed2b","ContactNew":"d3de4bc2","ShiftNew":"1378141d","MetricNew":"6b0baa89","MetricShow":"b81d5232","NonprofitNew":"d3de4bc2","VenueNew":"d3de4bc2","VolunteertNew":"e280bc48","Home":"94a0e7dc","Login":"31d6cfe0","SettingNew":"ca6df252","SettingShow":"9b8d37cf","UserNew":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
